import React/*, { Component }*/ from "react";
import PropTypes from "prop-types";
import { isEmpty } from "../helpers";
import localize from "../hoc/localize";

class Toolbar extends React.Component {
    static propTypes = {
        onEditScrtooltip: PropTypes.bool,
        atBottom: PropTypes.bool,
        onTop: PropTypes.bool,
        forPartException: PropTypes.bool
    };
    state = {
        showToolbar: false
    };
    static getDerivedStateFromProps(nextProps, prevState) {

        if (!isEmpty(nextProps.children)) {

            return { showToolbar: true };
        } else {
            return { showToolbar: false };
        }
    }
    render() {
        if (this.props.onTop)
            return (
                <React.Fragment>
                    {this.state.showToolbar && (
                        <div className="grid-toolbar top">{this.props.children}</div>
                    )}
                </React.Fragment>
            );
        else if (this.props.atBottom)
            return (
                <React.Fragment>
                    {this.state.showToolbar && (
                        <div className="grid-toolbar bottom">{this.props.children}</div>
                    )}
                </React.Fragment>
            );
        else if (this.props.onEditScrtooltip)
            return (
                <React.Fragment>
                    {this.state.showToolbar && (
                        <ul className="grid-toolbar edit">{this.props.children}</ul>
                    )}
                </React.Fragment>
            );
        else if (this.props.forPartException)
            return (
                <React.Fragment>
                    {this.state.showToolbar && (
                        <ul className="grid-toolbar edit part-exception">{this.props.children}</ul>
                    )}
                </React.Fragment>
            );
        else
            return (
                <React.Fragment>
                    {this.state.showToolbar && (
                        <ul className={this.props.hasSummaryLine ? "grid-toolbar so" : "grid-toolbar"}>{this.props.children}</ul>
                    )}
                </React.Fragment>
            );
    }
}
export default localize(Toolbar);


// WEBPACK FOOTER //
// ./src/components/Toolbar.js